<template>
  <div class="download-container">
    <header class="download-hd">
      <div
        class="download-hd-wrapper"
        v-scroll-animate="{
          animation: 'fadeInDown',
        }"
      >
        <h4 class="download-hd-subTitle">下载中心</h4>
        <h2 class="download-hd-title">获取软件、插件与手册</h2>
        <h4 class="download-hd-subTitle">
          与和值得信任的合作伙伴一起探索求知、学习实践和开展创新。
        </h4>
        <h4 class="download-hd-subTitle">技术支持：4000-025-828</h4>
      </div>
    </header>

    <AnchorTabs ref="downloadAnchorTabsRef" :tabList="tabList" />

    <div class="cardBox">
      <!-- 软件产品 -->
      <div id="software" class="title">下载设计软件</div>
      <template v-if="softwareList.length > 0">
        <div class="cardArea">
          <div
            v-for="(item, index) in softwareList"
            :key="index"
            class="softwareCard"
            v-scroll-animate="{
              animation: 'fadeInUp',
              delay: index * 200,
            }"
          >
            <!-- 封面 -->
            <img
              v-if="item.picUrl"
              :src="item.picUrl"
              alt="icon"
              class="cover"
            />
            <img
              v-else
              src="@/assets/images/fallbackImg.png"
              alt="FallbackImg"
              class="cover"
            />
            <el-tooltip effect="dark" :content="item.title" placement="top">
              <div class="title">{{ item.title }}</div>
            </el-tooltip>
            <el-tooltip effect="dark" :content="item.summary">
              <div class="summary">{{ item.summary }}</div>
            </el-tooltip>

            <!-- logo -->
            <div class="logoBox">
              <img
                v-if="item.logoUrl"
                :src="item.logoUrl"
                alt="icon"
                class="logo"
              />
              <img
                v-else
                src="@/assets/images/fallbackImg.png"
                alt="FallbackImg"
                class="logo"
              />
            </div>
            <div class="updateTime">
              <span v-if="item.fileUpdateTime">
                更新时间：{{ item.fileUpdateTime }}
              </span>
            </div>
            <!-- <div
              style="
                width: 76px;
                height: 21px;
                margin: 20px auto 0;
                display: flex;
                gap: 16px;
                display: none;
              "
            >
              <img
                alt="system"
                src="@/views/web/home/imgs/icon1.svg"
                width="22px"
              />
              <div style="width: 1px; height: 21px; background: #d8d8d8"></div>
              <img
                alt="windows"
                src="@/views/web/home/imgs/icon2.svg"
                width="21px"
              />
            </div> -->

            <DownLoad
              class="downloadBtn"
              :id="item.id"
              :type="'1'"
              :btnLabel="item.downloadButtonName"
              :fileUrl="item.fileUrl"
              :fileName="item.fileTitle"
            />
          </div>
        </div>
      </template>
      <template v-else>
        <EmptyPage :name="'暂无数据!'" />
      </template>
      <!-- 用户手册 -->
      <div id="manual" class="title">下载产品手册</div>
      <template v-if="manualList.length > 0">
        <div class="cardArea">
          <div
            v-for="(item, index) in manualList"
            :key="index"
            class="manualCard"
            v-scroll-animate="{
              animation: 'fadeInUp',
              delay: index * 200,
            }"
          >
            <img
              v-if="item.picUrl"
              :src="item.picUrl"
              class="icon"
              alt="manual"
            />
            <img
              v-else
              src="@/assets/images/fallbackImg.png"
              alt="FallbackImg"
              class="icon"
            />
            <el-tooltip effect="dark" :content="item.title" placement="top">
              <div class="title">{{ item.title }}</div>
            </el-tooltip>

            <DownLoad
              class="downloadBtn"
              :id="item.id"
              :type="'2'"
              :btnLabel="item.downloadButtonName"
              :fileUrl="item.fileUrl"
              :fileName="item.fileTitle"
            />
          </div>
        </div>
      </template>
      <template v-else>
        <EmptyPage :name="'暂无数据!'" />
      </template>
    </div>

    <!-- <ProductGet
      title="DELAUNEY"
      subTitle="Serving over 1000 corporate clients and 20000+designer users!"
      :bgImage="require('@/views/web/home/imgs/downloadBottom.png')"
      :downLoadBtn="{
        show: false,
      }"
    /> -->
  </div>
</template>

<script>
import DownLoad from "@/components/DownLoad";
import AnchorTabs from "@/components/AnchorTabs.vue";
import ProductGet from "@/components/ProductGet.vue";
import downLoadBtn from "@/views/web/home/imgs/downloadBtn.png";

import EmptyPage from "@/components/EmptyPage.vue";

import { softwareAllApi } from "@/api/website";
console.log("process.env.BASE_URL---", process.env.BASE_URL);
export default {
  data() {
    return {
      softwareList: [],
      manualList: [],
      tabList: [
        {
          name: "软件下载",
          value: "software",
        },
        {
          name: "产品手册",
          value: "manual",
        },
      ],
      downLoadBtnPath: downLoadBtn,
      anchor: "sofeware",
    };
  },
  components: {
    ProductGet,
    AnchorTabs,
    DownLoad,
    EmptyPage,
  },
  async created() {
    await this.getSoftwareList();
    this.anchor = this.$route.query.anchor;
    if (this.anchor) {
      this.$nextTick(() => {
        this.$refs.downloadAnchorTabsRef.handleTabClick(this.anchor);
      });
    }
  },

  methods: {
    async getSoftwareList() {
      await softwareAllApi().then((res) => {
        // console.log(res.data);
        if (res.code == 200 && res.success) {
          // 查找出已启用且生效的数据
          let nowTimeString = this.$uniFun.getNowTime();
          let temp1 = res.data.softwareList.filter(
            (item) => nowTimeString > item.effectiveTime,
          );
          let temp2 = res.data.softwareHelpList.filter(
            (item) => nowTimeString > item.effectiveTime,
          );

          this.softwareList = temp1.map((item) => {
            let ext1 = item.ext1
              ? JSON.parse(item.ext1)
              : { logoList: [], logoUrlId: "" }; //logo图

            return {
              id: item.id,
              title: item.name,
              downloadButtonName: item.downloadButtonName,
              picUrl:
                item.coverUrlIdList.length > 0
                  ? item.coverUrlIdList[0].path
                  : "",
              summary: item.description,
              fileUrl:
                item.pathUrlIdList.length > 0 ? item.pathUrlIdList[0].path : "",
              fileTitle:
                item.pathUrlIdList.length > 0
                  ? item.pathUrlIdList[0].fileTitle
                  : "",
              logoUrl: ext1.logoList.length > 0 ? ext1.logoList[0].path : "",
              fileUpdateTime:
                item.pathUrlIdList.length > 0
                  ? item.pathUrlIdList[0].createTime.substring(0, 10)
                  : "",
            };
          });
          console.log(346, this.softwareList);

          this.manualList = temp2.map((item) => {
            return {
              id: item.id,
              title: item.name,
              downloadButtonName: item.downloadButtonName,
              picUrl:
                item.coverUrlIdList.length > 0
                  ? item.coverUrlIdList[0].path
                  : "",
              fileUrl:
                item.pathHelpUrlIdList.length > 0
                  ? item.pathHelpUrlIdList[0].path
                  : "",
              fileTitle:
                item.pathHelpUrlIdList.length > 0
                  ? item.pathHelpUrlIdList[0].fileTitle
                  : "",
            };
          });
        }
      });
    },
  },
};
</script>
<style scoped lang="scss">
@import "@/assets/styles/common.scss";
.download-container {
  width: 100%;
  background: #fff;
  //padding-bottom: 100px;
}

.download-hd {
  width: 100%;
  height: 320px;
  background: url("~@/views/web/home/imgs/downloadTop.png") no-repeat center;
  background-size: cover;
  .download-hd-wrapper {
    width: 1049px;
    padding-top: 70px;
    margin: 0 auto;
  }
  .download-hd-title {
    margin-bottom: 20px;
    font-weight: bold;
    font-size: 28px;
    color: #ffffff;
    line-height: 28px;
    font-style: normal;
  }
  .download-hd-subTitle {
    margin-bottom: 20px;
    font-weight: 400;
    font-size: 18px;
    color: #ffffff;
    line-height: 27px;
    font-style: normal;
  }
}

.cardBox {
  display: flex;
  flex-direction: column;
  gap: 40px;
  width: 1048px;
  margin: 0 auto;
  padding: 40px 0;

  .title {
    height: 24px;
    font-weight: bold;
    font-size: 24px;
    color: #1d1d1f;
    line-height: 24px;
    text-align: left;
    font-style: normal;
  }
  .cardArea {
    width: 100%;
    height: auto;
    flex-wrap: wrap; /* 允许换行 */
    align-content: flex-start; /* 控制多行内容的对齐方式 */
    display: flex;
    gap: 29px;
  }
}

.softwareCard {
  width: 240px;
  height: 352px;
  background: #ffffff;
  border-radius: 8px;
  border: 1px solid #dbdbdb;
  text-align: center;
  // padding: 24px 20px;
  .cover {
    width: 100%;
    height: 120px;
    border-top-left-radius: 8px;
    border-top-right-radius: 8px;
  }
  .logoBox {
    margin-bottom: 20px;
    .logo {
      width: 48px;
      height: 48px;
      margin: 0 auto;
    }
  }

  .title {
    width: fit-content;
    height: 18px;
    font-weight: bold;
    font-size: 18px;
    color: #000000;
    line-height: 18px;
    text-align: center;
    font-style: normal;
    margin: 18px auto 0;
    @extend .text-truncate-multiline;
    --line-clamp: 1;
  }

  .summary {
    @extend .text-truncate-multiline;
    --line-clamp: 1;
    height: 20px;
    margin: 8px auto 24px;
    width: 100%;
    font-weight: 400;
    font-size: 16px;
    color: #000000;
    line-height: 20px;
    text-align: center;
    font-style: normal;
  }
  .updateTime {
    height: 12px;
    font-size: 12px;
    line-height: 12px;
    font-weight: 400;
    color: #999999;
  }
  .downloadBtn {
    margin: 16px auto 0;
  }

  cursor: pointer;
  transition: all 0.3s ease-in-out;
  &:hover {
    transform: translateY(-5px); // Slight lift effect on hover
  }
}

.manualCard {
  width: 240px;
  height: 280px;
  background: #ffffff;
  border-radius: 8px;
  border: 1px solid #dbdbdb;
  padding-top: 32px;
  text-align: center;

  .icon {
    width: 84px;
    height: 114px;
  }

  .title {
    width: fit-content;
    height: 20px;
    font-weight: bold;
    font-size: 16px;
    color: #1d1d1f;
    line-height: 20px;
    text-align: center;
    font-style: normal;
    margin: 12px auto 0;
    @extend .text-truncate-multiline;
    --line-clamp: 1;
  }
  .downloadBtn {
    width: 100px;
    margin: 28px auto 0;
  }

  cursor: pointer;
  transition: all 0.3s ease-in-out;
  &:hover {
    transform: translateY(-5px); // Slight lift effect on hover
  }
}
</style>
